import { PAGE_REFERER } from './constants';

export const NotificationConstants = {
  // 1 #現場監督からの巡回記録の指摘の通知(強)
  safetyDiariesPointedOutFromManager: {
    messageTypeId: 1,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesConfirm',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '是正する',
    beforePageName: null,
  },
  // 2 #現場監督からの巡回記録の周知の通知
  safetyDiariesInformFromManager: {
    messageTypeId: 2,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesConfirm',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 3 #職長からの巡回記録の指摘の通知(強)
  safetyDiariesPointedOutFromForeman: {
    messageTypeId: 3,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesRegister',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '是正する',
    beforePageName: null,
  },
  // 4 #職長からの巡回記録の周知の通知
  safetyDiariesInformFromForeman: {
    messageTypeId: 4,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesConfirm',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 5 #支店管理者からの現場マスタ(現場情報)の変更の通知
  fieldUpdatedFromBranch: {
    messageTypeId: 5,
    icon: 'i-settei',
    link: true,
    linkTo: 'FieldsDetail',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '',
    beforePageName: PAGE_REFERER.fields.key,
  },
  // 6 #現場監督からの現場マスタ(現場情報)の変更の通知
  fieldUpdatedFromManager: {
    messageTypeId: 6,
    icon: 'i-settei',
    link: true,
    linkTo: 'FieldsDetail',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '',
    beforePageName: PAGE_REFERER.fields.key,
  },
  // 7 #現場監督からの巡回記録の是正報告の通知
  safetyDiariesRecoveryFromManager: {
    messageTypeId: 7,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesRecoveryApproval',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 8 #職長からの巡回記録の是正報告の通知
  safetyDiariesRecoveryFromForeman: {
    messageTypeId: 8,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesRecoveryApproval',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 9 #現場監督からの巡回記録の是正承認の通知
  safetyDiariesRecoveryApprovedFromManager: {
    messageTypeId: 9,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesConfirm', //approval?
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 10 #職長からの巡回記録の是正承認の通知
  safetyDiariesRecoveryApprovedFromForeman: {
    messageTypeId: 10,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesConfirm',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 11 #現場監督からの巡回記録の是正否認の通知(強)
  safetyDiariesRecoveryRejectedFromManager: {
    messageTypeId: 11,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesRecoveryRegister',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '是正する',
    beforePageName: null,
  },
  // 12 #職長からの巡回記録の是正否認の通知(強)
  safetyDiariesRecoveryRejectedFromForeman: {
    messageTypeId: 12,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesRecoveryRegister',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '是正する',
    beforePageName: null,
  },
  // 13 #現場監督からの巡回記録の当日作業連絡の通知
  safetyDiariesWorkCommunicationFromManager: {
    messageTypeId: 13,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesConfirm',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 14 #職長からの巡回記録の当日作業連絡の通知
  safetyDiariesWorkCommunicationFromForeman: {
    messageTypeId: 14,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesConfirm',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 15 #支店管理者からの巡回記録の指摘の通知(強)
  safetyDiariesPointedOutFromBranch: {
    messageTypeId: 15,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesRegister',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '是正する',
    beforePageName: null,
  },
  // 16 #支店管理者からの巡回記録の周知の通知
  safetyDiariesInformFromBranch: {
    messageTypeId: 16,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesConfirm',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 17 #支店管理者からの巡回記録の是正報告の通知
  safetyDiariesRecoveryFromBranch: {
    messageTypeId: 17,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesRecoveryApproval',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 18 #支店管理者からの巡回記録の是正承認の通知
  safetyDiariesRecoveryApprovedFromBranch: {
    messageTypeId: 18,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesRecoveryApproval',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 19 #支店管理者からの巡回記録の是正否認の通知(強)
  safetyDiariesRecoveryRejectedFromBranch: {
    messageTypeId: 19,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesRecoveryRegister',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '是正する',
    beforePageName: null,
  },
  // 20 #支店管理者からの巡回記録の当日作業連絡の通知
  safetyDiariesWorkCommunicationFromBranch: {
    messageTypeId: 20,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesConfirm',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 21 #番頭からの巡回記録の指摘の通知(強)
  safetyDiariesPointedOutFromPartner: {
    messageTypeId: 21,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesRegister',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '是正する',
    beforePageName: null,
  },
  // 22 #番頭からの巡回記録の是正報告の通知
  safetyDiariesRecoveryFromPartner: {
    messageTypeId: 22,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesRecoveryApproval',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 23 #番頭からの巡回記録の是正承認の通知
  safetyDiariesRecoveryApprovedFromPartner: {
    messageTypeId: 23,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesRecoveryApproval',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 24 #番頭からの巡回記録の是正否認の通知(強)
  safetyDiariesRecoveryRejectedFromPartner: {
    messageTypeId: 24,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesRecoveryRegister',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '是正してください',
    beforePageName: null,
  },
  // 25 #番頭からの巡回記録の周知の通知
  safetyDiariesInformFromPartner: {
    messageTypeId: 25,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesConfirm',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 26 #番頭からの巡回記録の当日作業連絡の通知
  safetyDiariesWorkCommunicationFromPartner: {
    messageTypeId: 26,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesConfirm',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },

  // 27,28,29は採番なし

  // 30 #本社管理者からの現場マスタ(現場情報)の変更の通知
  fieldUpdatedFromPrime: {
    messageTypeId: 30,
    icon: 'i-settei',
    link: true,
    linkTo: 'FieldsDetail',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '',
    beforePageName: PAGE_REFERER.fields.key,
  },
  // 31 #本社管理者からの巡回記録の指摘の通知(強)
  safetyDiariesPointedOutFromPrime: {
    messageTypeId: 31,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesRegister',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '是正する',
    beforePageName: null,
  },
  // 32 #本社管理者からの巡回記録の周知の通知
  safetyDiariesInformFromPrime: {
    messageTypeId: 32,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesConfirm',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 33 #本社管理者からの巡回記録の是正報告の通知
  safetyDiariesRecoveryFromPrime: {
    messageTypeId: 33,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesRecoveryApproval',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 34 #本社管理者からの巡回記録の是正承認の通知
  safetyDiariesRecoveryApprovedFromPrime: {
    messageTypeId: 34,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesRecoveryApproval',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 35 #本社管理者からの巡回記録の是正否認の通知(強)
  safetyDiariesRecoveryRejectedFromPrime: {
    messageTypeId: 35,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesRecoveryRegister',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '是正する',
    beforePageName: null,
  },
  // 36 #本社管理者からの巡回記録の当日作業連絡の通知
  safetyDiariesWorkCommunicationFromPrime: {
    messageTypeId: 36,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesConfirm',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },

  // 37,38,39は採番なし

  // 40 #アカウント更新
  masterAccountUpdated: {
    messageTypeId: 40,
    icon: 'i-settei',
    link: true,
    linkTo: 'UserProfileForm',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 41 #新規現場申請承認
  masterNewFieldApproved: {
    messageTypeId: 41,
    icon: 'i-settei',
    link: true,
    linkTo: 'Dashboard',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 42 #新規現場申請否認
  masterNewFieldRejected: {
    messageTypeId: 42,
    icon: 'i-settei',
    link: true,
    linkTo: 'FieldsDetail',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '',
    beforePageName: PAGE_REFERER.fieldRequestList.key,
  },
  // 43 #会社情報の更新(元請本社)
  masterCompanyInformationUpdated: {
    messageTypeId: 43,
    icon: 'i-settei',
    link: true,
    linkTo: 'PrimeCompanyPreview',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '',
    beforePageName: null,
  },

  // 44は廃番

  // 45 #会社情報の更新(協力会社情報)
  masterPartnerCompanyInformationUpdated: {
    messageTypeId: 45,
    icon: 'i-settei',
    link: true,
    linkTo: 'PartnerCompanyPreview',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 46 #施工体系図紐付き
  fieldTreeLinked: {
    messageTypeId: 46,
    icon: 'i-sekoutaikei',
    link: true,
    linkTo: 'FieldTreePage',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 47 #施工体系図紐付き解除
  fieldTreeUnlinked: {
    messageTypeId: 47,
    icon: 'i-sekoutaikei',
    link: true,
    linkTo: 'FieldTreePage',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 48 #施工体系図申請(強)
  fieldTreeRequest: {
    messageTypeId: 48,
    icon: 'i-sekoutaikei',
    link: true,
    linkTo: 'FieldTreePage',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '施工体系図を開く',
    beforePageName: null,
  },
  // 49 #施工体系図承認
  fieldTreeApproved: {
    messageTypeId: 49,
    icon: 'i-sekoutaikei',
    link: true,
    linkTo: 'FieldTreePage',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 50 #施工体系図否認(強)
  fieldTreeRejected: {
    messageTypeId: 50,
    icon: 'i-sekoutaikei',
    link: true,
    linkTo: 'FieldTreePage',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '施工体系図を開く',
    beforePageName: null,
  },
  // 51 #施工体系図の協力会社削除
  fieldTreePartnerCompanyDeleted: {
    messageTypeId: 51,
    icon: 'i-sekoutaikei',
    link: true,
    linkTo: '',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 52 #施工体系図の協力会社作業完了
  fieldTreePartnerCompanyWorkCompleted: {
    messageTypeId: 52,
    icon: 'i-sekoutaikei',
    link: true,
    linkTo: 'FieldTreePage',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 53 #施工体系図の協力会社作業完了
  fieldTreePartnerCompanyWorkResumed: {
    messageTypeId: 53,
    icon: 'i-sekoutaikei',
    link: true,
    linkTo: 'FieldTreePage',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 54 #作業予定登録通知
  conferenceWorkPlansCreatedNotification: {
    messageTypeId: 54,
    icon: 'i-schedule-1',
    link: true,
    linkTo: 'WorkSchedule',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 55 #作業予定承認の解除通知
  conferenceWorkPlansApprovedReleaseNotification: {
    messageTypeId: 55,
    icon: 'i-schedule-1',
    link: true,
    linkTo: 'WorkSchedule',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 56 #作業予定実績未入力通知(強)
  conferenceWorkPlansNotEnteredNotification: {
    messageTypeId: 56,
    icon: 'i-schedule-2',
    link: true,
    linkTo: 'WorkResultEdit',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '入力する',
    beforePageName: null,
  },

  // 57,58は廃番

  // 59 #作業予定更新通知
  conferenceWorkPlansUpdatedNotification: {
    messageTypeId: 59,
    icon: 'i-schedule-1',
    link: true,
    linkTo: 'WorkSchedule',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 60 # 巡回記録指摘の取り下げ
  safetyDiariesPointedOutDropped: {
    messageTypeId: 60,
    icon: 'i-jyunkaikiroku',
    link: true,
    linkTo: 'SafetyDiariesConfirm', //approval?
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 61 #新規現場作成
  masterNewFieldCreated: {
    messageTypeId: 61,
    icon: 'i-settei',
    link: true,
    linkTo: 'Dashboard',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 62 #作業実績登録通知
  conferenceWorkResultsCreatedNotification: {
    messageTypeId: 62,
    icon: 'i-schedule-2',
    link: true,
    linkTo: 'WorkResult',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 63 #ゲート予定登録通知
  conferenceGatePlansCreatedNotification: {
    messageTypeId: 63,
    icon: 'i-gate',
    link: true,
    linkTo: 'GatePassages',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 64 #揚重機予定登録通知
  conferenceCranePlansCreatedNotification: {
    messageTypeId: 64,
    icon: 'i-jyuuki',
    link: true,
    linkTo: 'CraneUses',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 65 #機材予定登録通知
  conferenceEquipmentPlansCreatedNotification: {
    messageTypeId: 65,
    icon: 'i-kizai',
    link: true,
    linkTo: 'MachineryUses',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 66 #作業実績承認の解除通知
  conferenceWorkResultsApprovedReleaseNotification: {
    messageTypeId: 66,
    icon: 'i-schedule-2',
    link: true,
    linkTo: 'WorkResult',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 67 #作業実績更新通知
  conferenceWorkResultsUpdatedNotification: {
    messageTypeId: 67,
    icon: 'i-schedule-2',
    link: true,
    linkTo: 'WorkResult',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 68 #ゲート予定更新通知
  conferenceGatePlansUpdatedNotification: {
    messageTypeId: 68,
    icon: 'i-gate',
    link: true,
    linkTo: 'GatePassages',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 69 #揚重機予定更新通知
  conferenceCranePlansUpdatedNotification: {
    messageTypeId: 69,
    icon: 'i-jyuuki',
    link: true,
    linkTo: 'CraneUses',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 70 #機材予定更新通知
  conferenceEquipmentPlansUpdatedNotification: {
    messageTypeId: 70,
    icon: 'i-kizai',
    link: true,
    linkTo: 'MachineryUses',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 71 #作業予定実績未入力通知(実績未コピー)
  conferenceWorkPlansNotEnteredAndNotCopyNotification: {
    messageTypeId: 71,
    icon: 'i-schedule-2',
    link: true,
    linkTo: 'WorkResultEdit',
    isSlide: true,
    isMasterSlide: false,
    blueButtonTitle: 'コピー',
    beforePageName: null,
  },
  // 72 #施工体系図申請催促(強)
  fieldTreeApprovalRequestReminder: {
    messageTypeId: 72,
    icon: 'i-sekoutaikei',
    link: true,
    linkTo: 'FieldTreePage',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '施工体系図を開く',
    beforePageName: null,
  },
  // 73 #JV登録通知
  masterNewJVCreated: {
    messageTypeId: 73,
    icon: 'i-settei',
    link: true,
    linkTo: 'Dashboard',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 74 #JV削除通知
  masterJVDeleted: {
    messageTypeId: 74,
    icon: 'i-settei',
    link: false,
    linkTo: '',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 75 #位置プラス連携完了
  linkedFieldToIchiPlus: {
    messageTypeId: 75,
    icon: '',
    link: true,
    linkTo: 'IchiPlusLinkageSettingDetail',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 100 #システム通知
  system: {
    messageTypeId: 100,
    icon: '',
    link: true,
    linkTo: '',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 101 #お問い合わせ
  contactDetail: {
    messageTypeId: 101,
    icon: '',
    link: true,
    linkTo: 'ContactDetail',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 102 #企業管理者申請 承認
  buildeeManagerGrantRequestApprove: {
    messageTypeId: 102,
    icon: '',
    link: false,
    linkTo: '',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 103 #企業管理者申請 拒否
  buildeeManagerGrantRequestReject: {
    messageTypeId: 103,
    icon: '',
    link: false,
    linkTo: '',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 200 #グリーンファイルの提出
  roanReportSubmit: {
    messageTypeId: 200,
    icon: '',
    link: false,
    linkTo: '',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 201 #グリーンファイルの差戻し
  roanReportSendBack: {
    messageTypeId: 201,
    icon: '',
    link: false,
    linkTo: '',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 202 #グリーンファイルの取下げ
  roanReportWithdraw: {
    messageTypeId: 202,
    icon: '',
    link: false,
    linkTo: '',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 203 #グリーンファイルの承認
  roanReportApprove: {
    messageTypeId: 203,
    icon: '',
    link: false,
    linkTo: '',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 204 #グリーンファイル承認後修正中
  roanReportModifyApprove: {
    messageTypeId: 204,
    icon: '',
    link: false,
    linkTo: '',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 205 #グリーンファイル承認後差戻し
  roanReportSendBackApprove: {
    messageTypeId: 205,
    icon: '',
    link: false,
    linkTo: '',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 206 #随時書類の提出通知
  roanReportAsNeededSubmit: {
    messageTypeId: 206,
    icon: '',
    link: false,
    linkTo: '',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 207 #随時書類の差戻し通知
  roanReportAsNeededSendBack: {
    messageTypeId: 207,
    icon: '',
    link: false,
    linkTo: '',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 208 #随時書類の取下げ通知
  roanReportAsNeededWithdraw: {
    messageTypeId: 208,
    icon: '',
    link: false,
    linkTo: '',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 209 #随時書類の受領通知
  roanReportAsNeededReceived: {
    messageTypeId: 209,
    icon: '',
    link: false,
    linkTo: '',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 210 #随時書類の受領後差戻し通知
  roanReportAsNeededSendBackReceived: {
    messageTypeId: 210,
    icon: '',
    link: false,
    linkTo: '',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 220 #未提出グリーンファイルの督促
  roanReportReminder: {
    messageTypeId: 220,
    icon: '',
    link: false,
    linkTo: '',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 230 #グリーンファイルの出力準備完了
  roanReportExport: {
    messageTypeId: 230,
    icon: '',
    link: false,
    linkTo: '',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 240 # 指導実施
  roanImplementationGuidance: {
    messageTypeId: 240,
    icon: '',
    link: false,
    linkTo: '',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 250 #指導に対する返信
  roanTeachingReply: {
    messageTypeId: 250,
    icon: '',
    link: false,
    linkTo: '',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 260 #協力会社のその他安全書類提出通知
  partnerOtherDocumentSubmitted: {
    messageTypeId: 260,
    icon: '',
    link: false,
    linkTo: '',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 270 #作業員名簿の代理提出通知
  roanAgencySubmit: {
    messageTypeId: 270,
    icon: '',
    link: false,
    linkTo: '',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 271 #随時書類の代理提出通知
  roanReportAsNeededAgencySubmit: {
    messageTypeId: 271,
    icon: '',
    link: false,
    linkTo: '',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 280 #作業員名簿の代理取り下げ通知
  roanWithdrawalAgencySubmit: {
    messageTypeId: 280,
    icon: '',
    link: false,
    linkTo: '',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 281 #随時書類の代理取下げ通知
  roanReportAsNeededWithdrawalAgencySubmit: {
    messageTypeId: 281,
    icon: '',
    link: false,
    linkTo: '',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 301 #入退場：CCUSへの現場契約情報登録の成功通知
  successToRegisterSiteForCcusNotification: {
    messageTypeId: 301,
    icon: '',
    link: true,
    linkTo: 'FieldsDetail',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '',
    beforePageName: PAGE_REFERER.fields.key,
  },
  // 302 #入退場：CCUSへの現場契約情報登録の失敗通知（lambda)
  failToRegisterSiteForCcusOnLambdaNotification: {
    messageTypeId: 302,
    icon: '',
    link: true,
    linkTo: 'FieldsDetail',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '確認',
    beforePageName: PAGE_REFERER.fields.key,
  },
  // 303 #入退場：CCUSへの現場契約情報登録の失敗通知（API)
  failToRegisterSiteForCcusOnApiNotification: {
    messageTypeId: 303,
    icon: '',
    link: true,
    linkTo: 'FieldsDetail',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '確認',
    beforePageName: PAGE_REFERER.fields.key,
  },
  // 304 #入退場：CCUSへの入退場実績の登録に失敗したことの通知
  failToRegisterSiteForCcusAtInOutResultNotification: {
    messageTypeId: 304,
    icon: '',
    link: true,
    linkTo: 'InOutResult',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '確認',
    beforePageName: null,
  },
  // 305 #入退場：就業履歴の承認要求通知
  workHistoryApprovalRequestNotification: {
    messageTypeId: 305,
    icon: '',
    link: true,
    linkTo: 'InOutResult',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 306 #入退場：就業履歴の承認通知
  workHistoryApprovalNotification: {
    messageTypeId: 306,
    icon: '',
    link: true,
    linkTo: 'InOutResult',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 307 #入退場：就業履歴の承認解除通知
  workHistoryDisApprovalNotification: {
    messageTypeId: 307,
    icon: '',
    link: true,
    linkTo: 'InOutResult',
    isSlide: false,
    isMasterSlide: false,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 310 #CCUSへの施工体制連携成功
  successToRegisterFieldTreeForCcusNotification: {
    messageTypeId: 310,
    icon: 'i-sekoutaikei',
    link: true,
    linkTo: 'FieldTreePage',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 311 #CCUSへの施工体制連携異常
  failedToRegisterFieldTreeForCcusNotification: {
    messageTypeId: 311,
    icon: 'i-sekoutaikei',
    link: true,
    linkTo: 'FieldTreePage',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '確認する',
    beforePageName: null,
  },
  // 312 #CCUSへの施工体制連携一部異常
  partiallyFailedToRegisterFieldTreeForCcusNotification: {
    messageTypeId: 312,
    icon: 'i-sekoutaikei',
    link: true,
    linkTo: 'FieldTreePage',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 313 #CCUSへの施工体系作業員連携成功
  successToRegisterFieldTreeWorkerForCcusNotification: {
    messageTypeId: 313,
    icon: 'i-sekoutaikei',
    link: true,
    linkTo: 'FieldTreePage',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 314 #CCUSへの施工体系作業員異常
  failedToRegisterFieldTreeWorkerForCcusNotification: {
    messageTypeId: 314,
    icon: 'i-sekoutaikei',
    link: true,
    linkTo: 'FieldTreePage',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '確認する',
    beforePageName: null,
  },
  // 315 #CCUSへの施工体系作業員一部異常（現場監督向け）
  partiallyFailedToRegisterFieldTreeWorkerForCcusNotificationToManager: {
    messageTypeId: 315,
    icon: 'i-sekoutaikei',
    link: true,
    linkTo: 'FieldTreePage',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 316 #CCUSへの施工体系作業員一部異常（協力会社管理者向け）
  partiallyFailedToRegisterFieldTreeWorkerForCcusNotificationToPartner: {
    messageTypeId: 316,
    icon: 'i-sekoutaikei',
    link: true,
    linkTo: 'FieldTreePage',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '',
    beforePageName: null,
  },
  // 900 #新規現場申請
  masterFieldCreatedRequest: {
    messageTypeId: 900,
    icon: 'i-settei',
    link: true,
    linkTo: 'FieldsDetail',
    isSlide: false,
    isMasterSlide: true,
    blueButtonTitle: '',
    beforePageName: PAGE_REFERER.fieldRequestList.key,
  },
};

export const NotificationLevel = {
  weak: 1,
  strong: 2,
};



// WEBPACK FOOTER //
// ./src/utilities/notificationConstants.js